import React from 'react'
import { Loader, l } from '@manychat/manyui'

import { useLoader } from 'apps/aiAutomation/hooks/useLoader'

const steps = [
  {
    title: l.translate('Connecting to Instagram...'),
    subline: l.translate('Accessing your bio and recent comments'),
  },
  {
    title: l.translate('Understanding your industry...'),
    subline: l.translate('Figuring out the space you operate in'),
  },
  {
    title: l.translate('Reading your comments...'),
    subline: l.translate('Learning how you talk to your audience'),
  },
  {
    title: l.translate('Almost there...'),
    subline: l.translate('AI behavior is being set up'),
  },
]

export const BehaviorLoader = () => {
  const stepIndex = useLoader({ steps })

  return (
    <div className="w-full text-center">
      <Loader size={24} />
      <h3 className="m-t-lg">{l.getString(steps[stepIndex].title)}</h3>
      <p className="text-secondary">{l.getString(steps[stepIndex].subline)}</p>
    </div>
  )
}
